module.exports = __webpack_public_path__ + "static/sharemagazines-b05c3a52998e8d5136791f94dfe1a0bd.png";